export default __webpack_public_path__ + "static/plug_w.e49cdbea64b8bb561e4b8f001a9fdd9c.svg";